import React, { useEffect, useState } from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import CustomTable from "../../components/table/Table";
import { clearMessage } from "../../redux/Slice/message";
import { toast } from "sonner";
import { useDispatch, useSelector } from "react-redux";
import { fetchCustomers } from "../../redux/Slice/customerSlice";
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import { setLoading } from "../../redux/Slice/loaderSlice";

const columns = [
  { id: "customerNo", label: "Customer No", minWidth: 150, align: "start" },
  { id: "contactPerson", label: "Contact Person (Company)", minWidth: 200, align: "start" },
  { id: "contactInfo", label: "Contact Info", minWidth: 250, align: "start" },
  { id: "planPrices", label: "Plan Prices", minWidth: 200, align: "start" },
  { id: "subscribedPlan", label: "Subscribed Plan", minWidth: 200, align: "start" },
  {
    id: "action",
    label: "Action",
    minWidth: 150,
    align: "center",
    actionType: [{ edit: true, view: true }],
  },
];

export const Customerplan = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const message = useSelector((state) => state.message);
  const { customers, totalCount } = useSelector((state) => state.customer);
  console.log("Customers:",customers);


  const transformCustomers = (customers) =>
    customers.map((customer) => ({
      _id:customer._id,
      customerNo: customer.customer_id || "N/A", // Replace with the correct field
      contactPerson: `${customer.contactPerson[0]?.name || "N/A"}\n(${customer.companyName || "N/A"})`,
      contactInfo: `${customer.company_email || "N/A"}, ${customer.contactPerson[0]?.phoneNumber || "N/A"}`, 
      planPrices:  customer.plans.find((plan) => plan.active === true)?.price || "N/A",
      subscribedPlan: customer.plans.find((plan) => plan.active === true)?.name || "N/A", 
      action: "",
    }));
  

  const modifiedRows = customers ? transformCustomers(customers) : [];


  useEffect(() => {
    if (message?.message) {
      toast(message.message)
      dispatch(clearMessage())
    }
  }, [message, dispatch])

  useEffect(()=>{
    const params = {
      page: page,
      limit: rowsPerPage,
      searchTerm: searchTerm
    }
    // dispatch(setLoading(true));
    dispatch(fetchCustomers(params))
    // .then(() => dispatch(setLoading(false)))  
    // .catch(() => dispatch(setLoading(false)));
  },[dispatch, page, rowsPerPage, searchTerm]);


  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    setPage(1);
};

const handleExport = () => {
console.log("Exporting data...");
};

  const handleEdit = (row) => {
    if (row._id) {
      navigate(`/customerplans/${row._id}`)
    } else {
      console.log("No Plan ID found for this row", row);
    }
  };

  const handleView = (row) => {
    if (row._id) {
      navigate(`/customerview/${row._id}`)
    } else {
      console.log("No Plan ID found for this row", row);
    }
  };

  return (
    <div className="content">
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Typography variant="h5">
          Customer Plans <Typography component="span">({customers.length})</Typography>
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <TextField
            size="small"
            placeholder="Search by Customer Name"
            fullWidth
            onChange={handleSearch}
            sx={{ maxWidth: 300, mr: 2 }}
          />
          <Link to="/Createplans">
          <Button variant="contained" startIcon={<PersonAddAlt1Icon />} onClick={handleExport} sx={{ ml: 2, px: 3 }}>
            Add
          </Button>
          </Link>
        </Box>
      </Box>

      <CustomTable
        columns={columns}
        rows={modifiedRows}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        totalCount={totalCount}
        handleEdit={handleEdit}
        handleView={handleView}
      />
    </div>
  );
};
